import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { BehaviorSubject, Subscription } from "rxjs";
import { AuthService, UserModel } from "./datlaz/modules/auth";
import { TranslationService } from "./modules/i18n/translation.service";
import { locale as brLang } from "./modules/i18n/vocabs/br";
import { locale as chLang } from "./modules/i18n/vocabs/ch";
import { locale as deLang } from "./modules/i18n/vocabs/de";
import { locale as enLang } from "./modules/i18n/vocabs/en";
import { locale as esLang } from "./modules/i18n/vocabs/es";
import { locale as frLang } from "./modules/i18n/vocabs/fr";
import { locale as jpLang } from "./modules/i18n/vocabs/jp";
import { SplashScreenService } from "./_metronic/partials/layout/splash-screen/splash-screen.service";
import { TableExtendedService } from "./_metronic/shared/crud-table";
import Hotjar from "@hotjar/browser";
import { environment } from "../environments/environment";
import { ChatService } from "./modules/user-management/_services/chat.service";

@Component({
  selector: "body[root]",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  private unsubscribe: Subscription[] = [];
  userSid = this.authService.getLoggedUser().ecotx_sid
  isTyping =  new BehaviorSubject<boolean>(false)
  isSplashScreenLoaded = new BehaviorSubject<boolean>(false)
  constructor(
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private router: Router,
    private tableService: TableExtendedService,
    private authService: AuthService,
    protected $gaService: GoogleAnalyticsService,
    private chatService: ChatService,
    private cdr: ChangeDetectorRef
  ) {
    // register translations
    this.translationService.loadTranslations(
      brLang,
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.tableService.setDefaults();
  
        if (!this.authService.currentUserSubject.value || !this.authService.currentUserValue.accountSetup) {
          const authSubscription = this.authService.getMe().subscribe(async (res) => {
            this.handleUserResponse(res);
          });
          this.unsubscribe.push(authSubscription);
        } else {
          this.handleUserResponse(this.authService.currentUserSubject.value);
        }
      }
    });
  
    this.unsubscribe.push(routerSubscription);
    this.initHotjar();
  }
  
  private handleUserResponse(res: UserModel) {
    if (!res.accountSetup) {
      this.router.navigateByUrl("/account-setup");
      this.splashScreenService.hide();
    } else {
      this.splashScreenService.hide();
      window.scrollTo(0, 0);
      this.$gaService.set({ user_id: res.sid });
  
      setTimeout(() => {
        document.body.classList.add("page-loaded");
        this.isSplashScreenLoaded.next(true)
      }, 500);
    }
  }
  

  private initHotjar() {
    if (environment.hotjar.enabled) {
      Hotjar.init(environment.hotjar.siteId, environment.hotjar.hotjarVersion, {
        debug: environment.hotjar.debug
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  isChatOpen = false;
  userMessage = '';
  messages: { from: string; text: string }[] = [];

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
  }

  sendMessage() {
    this.isTyping.next(true)
    this.messages.push({ from: 'user', text: this.userMessage });
    this.chatService.sendMessage(this.userMessage, this.userSid).subscribe(
      (res: any) => {
        this.isTyping.next(false)
        this.messages.push({ from: 'bot', text: res[0].output });
        this.cdr.detectChanges();
      },
      (err) => {
        this.messages.push({ from: 'bot', text: 'Desculpe, ocorreu um erro.' });
      }
    );

  this.userMessage = '';
    
  }
  
  private scrollToBottom(): void {
    try {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    } catch(err) { }
  }
  
  ngAfterViewChecked() {
    this.scrollToBottom();
  }

}


